import React, { memo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Pagination from '@material-ui/lab/Pagination';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useTheme from '@material-ui/core/styles/useTheme';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import omit from 'lodash/omit';
import functions from 'lodash/functions';

import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';
function ADGMPagination(props) {
  const { classes, totalPages, currentPage, disabled, onPageChange, customClasses } = props;
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('xs'));

  const onChange = (_, value) => onPageChange(value);
  return (
    <Box display='flex' alignItems='center' className={classNames(classes.container, customClasses?.container)}>
      <Pagination
        count={totalPages}
        page={currentPage}
        disabled={disabled}
        size={mobileView ? 'small' : 'medium'}
        classes={{ ul: classes.list }}
        onChange={onChange}
        hideNextButton={currentPage === totalPages}
        hidePrevButton={currentPage === 1}
      />
      {!mobileView && <span className={classes.outOf}>{keyEmptyCheck('out_of', { s: totalPages })}</span>}
    </Box>
  );
}

ADGMPagination.propTypes = {
  classes: PropTypes.object.isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  customClasses: PropTypes.object,
};

ADGMPagination.defaultProps = {
  disabled: false,
  customClasses: {},
};

export default withStyles(styles)(
  memo(ADGMPagination, (prevProps, nextProps) =>
    isEqual(omit(prevProps, functions(prevProps.onPageChange)), omit(nextProps, functions(nextProps.onPageChange))),
  ),
);
